import React from 'react';
import { useTranslation } from 'react-i18next';
import {utils,writeFile}from 'xlsx';


const DownloadButton = ({ data, filename, sheetname, forModule, onDownload, BtnName }) => {
    const { t } = useTranslation();
    // console.warn('Excel DATA',data, filename, sheetname, forModule)
    const downloadExcel = () => {
        console.log('In download excel')
        const workbook = utils.book_new();
        const worksheet = utils.json_to_sheet(data);

        // Custom styling for the header row
        const headerCellStyle = {
            font: { bold: true },
            fill: { fgColor: { rgb: '6AA13C' } },
            alignment: { horizontal: 'center' },
        };
        utils.sheet_add_json(worksheet, data, { origin: 'A1' });
        worksheet['!cols'] = [{ width: 15 }, { width: 15 }]; // Adjust column widths

        // Apply custom styles to the header row
        Object.keys(data[0]).forEach((key, index) => {
            const cellRef = utils.encode_cell({ r: 0, c: index });
            worksheet[cellRef].s = headerCellStyle;
        });

        utils.book_append_sheet(workbook, worksheet, sheetname);
        if (typeof onDownload === 'function') {
            onDownload(true); // Pass any flag you want to send to the parent component
        }
        writeFile(workbook, filename);
    };

    return (

        <button className="" style={{border:'none', background:'none' , fontFamily:'Lato'}} onClick={downloadExcel}>
            <span>{t('btnGrpText.downloadOrders')}{forModule}</span>
        </button>
    );
};

export default DownloadButton;
